import { render, staticRenderFns } from "./Typeahead.vue?vue&type=template&id=5088880c&scoped=true&"
import script from "./Typeahead.vue?vue&type=script&lang=js&"
export * from "./Typeahead.vue?vue&type=script&lang=js&"
import style0 from "./Typeahead.vue?vue&type=style&index=0&id=5088880c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5088880c",
  null
  
)

export default component.exports